import './Contatti.css';

function Contatti() {
    return (
        <div className='contatti-container'>
            <h1 className='contatti-title'>Contatti</h1>

            <p>
                Per informazioni sulle nostre attività, sui progetti radiofonici o per proporre una
                collaborazione, puoi contattare l'Associazione Settemotivi – ODV tramite uno di questi canali:
            </p>

            <ul className='contatti-list'>
                <li>Via De Paoli n. 19 – 33170 Pordenone (PN)</li>
                <li>Tel. +39 348 993 5038</li>
                <li><a href="mailto:segreteria@settemotivi.it">segreteria@settemotivi.it</a></li>
                <li>PEC: <a href="mailto:settemotivi@pec.csvfvg.it">settemotivi@pec.csvfvg.it</a></li>
            </ul>
        </div>
    );
}

export default Contatti;
